import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import {
  ShoppingBag,
  DollarSign,
  ArrowDown,
  ArrowUp,
  Calendar,
} from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

interface BalanceCardProps {
  storeCode: string;
  storeName: string;
  previousBalance: string;
  entries: string;
  exits: string;
  dailyClosing: string;
  dailyBalance: string;
  createdAt: Date;
}

const BalanceCard: React.FC<BalanceCardProps> = ({
  storeCode,
  storeName,
  previousBalance,
  entries,
  exits,
  dailyClosing,
  dailyBalance,
  createdAt,
}) => {
  const formatDateTime = (date: Date) => {
    return format(date, "dd/MM/yyyy HH:mm:ss", { locale: ptBR });
  };

  return (
    <Card className="mt-6 w-full max-w-5xl shadow-lg border border-gray-200 rounded-lg">
      <CardHeader className="bg-[#F5CB2B] rounded-t-lg p-6">
        <CardTitle className="text-xl font-semibold">
          Informações do Saldo
        </CardTitle>
      </CardHeader>
      <CardContent className="p-8">
        <div className="grid grid-cols-2 gap-x-10 gap-y-6 text-gray-700">
          <div className="flex items-center">
            <div className="bg-blue-100 p-3 rounded-full mr-4">
              <ShoppingBag className="w-7 h-7 text-blue-500" />
            </div>
            <p className="text-lg">
              <strong>Loja:</strong> {storeName} ({storeCode})
            </p>
          </div>
          <div className="flex items-center">
            <div className="bg-gray-100 p-3 rounded-full mr-4">
              <DollarSign className="w-7 h-7 text-gray-500" />
            </div>
            <p className="text-lg">
              <strong>Saldo Anterior:</strong> R$ {previousBalance}
            </p>
          </div>
          <div className="flex items-center">
            <div className="bg-green-100 p-3 rounded-full mr-4">
              <ArrowUp className="w-7 h-7 text-green-500" />
            </div>
            <p className="text-lg">
              <strong>Entradas:</strong> R$ {entries}
            </p>
          </div>
          <div className="flex items-center">
            <div className="bg-red-100 p-3 rounded-full mr-4">
              <ArrowDown className="w-7 h-7 text-red-500" />
            </div>
            <p className="text-lg">
              <strong>Saídas:</strong> R$ {exits}
            </p>
          </div>
          <div className="flex items-center">
            <div className="bg-green-100 p-3 rounded-full mr-4">
              <DollarSign className="w-7 h-7 text-green-500" />
            </div>
            <p className="text-lg">
              <strong>Fechamento do Dia:</strong> R$ {dailyClosing}
            </p>
          </div>
          <div className="flex items-center">
            <div className="bg-yellow-100 p-3 rounded-full mr-4">
              <DollarSign className="w-7 h-7 text-yellow-500" />
            </div>
            <p className="text-lg">
              <strong>Saldo do Dia:</strong> R$ {dailyBalance}
            </p>
          </div>

          <div className="flex items-center">
            <div className="bg-yellow-100 p-3 rounded-full mr-4">
              <Calendar className="w-7 h-7 text-yellow-500" />
            </div>
            <p className="text-lg">
              <strong>Criado em:</strong> {formatDateTime(createdAt)}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BalanceCard;
